import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import ClientForm from './ClientForm';
import CardHeader from 'react/shared/components/true_link/main/form/wizard/CardHeader';
import NextPageButton from 'react/shared/components/true_link/main/form/wizard/NextPageButton';
import schema from 'react/shared/utils/schemas';
import trackUserData from 'react/signups/card/common/MarketoTracker';
import WizardCard from 'react/signups/card/common/WizardCard';
import profileDataShape from 'react/signups/card/shapes/ProfileData';

export default function ClientProfile({ moduleComplete, profileData, setProfileData }) {
  const validationSchema = Yup.object().shape({
    dob: schema.dateOfBirth.required(),
    firstName: schema.firstName.required(),
    lastName: schema.lastName.required(),
    mobile: schema.mobile.required(),
    referralCategory: schema.referralCategory,
    referralCategoryDetail: schema.referralCategoryDetail,
    referralName: schema.referralName,
  });

  const handleContinue = (values) => {
    trackUserData({
      FirstName: values.firstName,
      LastName: values.lastName,
      Phone: values.mobile,
      Referree_Code__c: values.referralName,
    });
    setProfileData({
      dob: values.dob,
      firstName: values.firstName,
      lastName: values.lastName,
      mobile: values.mobile,
      referralCategory: values.referralCategory,
      referralCategoryDetail: values.referralCategoryDetail,
      referralName: values.referralName,
    });
  };

  return (
    <WizardCard showBackButton={false}>
      <CardHeader>{'Tell us a little more about you'}</CardHeader>
      <Formik
        initialValues={profileData}
        onSubmit={handleContinue}
        validationSchema={validationSchema}
      >
        {({ handleChange, handleSubmit, setFieldTouched, values }) => (
          <>
            <ClientForm onChange={handleChange} setFieldTouched={setFieldTouched} values={values} />
            <NextPageButton disabled={moduleComplete} onClick={handleSubmit} />
          </>
        )}
      </Formik>
    </WizardCard>
  );
}

ClientProfile.propTypes = {
  moduleComplete: PropTypes.bool.isRequired,
  profileData: profileDataShape.isRequired,
  setProfileData: PropTypes.func.isRequired,
};
